import formatDistanceStrict from 'date-fns/formatDistanceStrict'
import { pt } from 'date-fns/locale'

// eslint-disable-next-line import/prefer-default-export
export const getFormatedCreatedAt = (format, referenceDate = null) => {
  let newDate

  if (!referenceDate) newDate = Date.now()

  const formatted = formatDistanceStrict(new Date(format), newDate, {
    addSuffix: false,
    locale: pt
  })

  return `${formatted} atrás`
}
